import React from 'react';

export default function Loading() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="mb-4 animate-bounce">
          <img 
            src="/logo-nobg.png" 
            alt="Loading" 
            className="w-16 h-auto mx-auto object-contain"
            style={{ aspectRatio: '2 / 1' }}
          />
        </div>
        <div className="text-lg text-text-secondary">Loading...</div>
      </div>
    </div>
  );
}
